import ThankForRegistration from './ThankForRegistration';

export default ThankForRegistration;
